import baseApi from "./baseApi"

export default  {
    async getProductGroups() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/productGroup");
        return result.data;
    },
    async addProductGroup(item) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post("/productGroup", item);
        return result.data;
    },
    async updateProductGroup(item) {
        let request = await baseApi.createHttpRequest();
        let result = await request.put("/productGroup", item);
        return result.data;
    }
}